import { useQuery } from "react-query";
import endpoints from "./EndPoints"
import { getAdvertDetails, getNearbyPlaces } from "./Services";





export const useGetAdvertDetails = (advertId:string |null) => {
  return useQuery([endpoints.getAdvertDetails,advertId], () => getAdvertDetails(advertId), {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export const useGetNearPlaces = (data:any) => {
  return useQuery([endpoints.getNearbyPlaces,data], () => getNearbyPlaces(data), {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

